import ProducerMessagesNews from './ProducerMessagesNews';
import ProducerMessagesOnboarding from './ProducerMessagesOnboarding';
import ProducerMessagesOrders from './ProducerMessagesOrders';
import ProducerMessagesWeightVolume from './ProducerMessagesWeightVolume';
import Container from '@carrot-deprecated/container';
import { useAppSelector } from '_common/hooks/reduxHooks';

const ProducerMessagesSection = () => {
  const { producerId } = useAppSelector(({ auth }) => {
    return {
      producerId: auth._id,
      billingAccount: auth.billingAccount
    };
  });

  return (
    <Container
      mb="xs"
      flex
      wrap="wrap"
      width="full"
      gap="s"
      alignItems="stretch"
    >
      <ProducerMessagesOnboarding />
      <ProducerMessagesOrders />
      <ProducerMessagesNews producerId={producerId} />
      <ProducerMessagesWeightVolume />
    </Container>
  );
};

export default ProducerMessagesSection;
